import { typography } from '../global/typography';
import { palette } from '../global/palette';

import type { Components } from '@mui/material/styles';

export const MuiStepper: Partial<Components> = {
  MuiMobileStepper: {
    styleOverrides: {
      root: {
        padding: '22px 12px',
      },
      dot: {
        backgroundColor: palette.grey[300],
      },
      dotActive: {
        backgroundColor: palette.primary.main,
      },
    },
  },
  MuiStepConnector: {
    styleOverrides: {
      line: {
        borderColor: palette.grey[400],
      },
      lineVertical: {
        height: 8,
        minHeight: 'unset',
      },
    },
  },
  MuiStepLabel: {
    styleOverrides: {
      label: {
        ...typography.subtitle2,
        color: palette.grey[600],
        '&[class*="Mui-active"]': {
          fontWeight: 600,
        },
        '&[class*="Mui-completed"]': {
          fontWeight: 600,
        },
        '&[class*="Mui-error"]': {
          fontWeight: 600,
        },
      },
    },
  },
  MuiStepIcon: {
    styleOverrides: {
      root: {
        color: palette.grey[400],
        '&[class*="Mui-active"]': {
          color: palette.primary.main,
        },
        '&[class*="Mui-completed"]': {
          color: palette.success.main,
        },
        '&[class*="Mui-error"]': {
          color: palette.error.main,
        },
      },
      text: {
        ...typography.subtitle2,
      },
    },
  },
};
